import React from "react";

import { Box, Typography } from '@material-ui/core';


import { Nav } from "../../components/Interface";

export const NotAllowed= () => {
  return (
    <>
      <Nav />

      <Box padding={3}>

        <h1>Not allowed</h1>
        <Typography>You do not have permission to view the page you were trying to access.</Typography>

      </Box>
    </>
  );
  
}